import type { PropsWithChildren } from 'react';

import { CostSummary } from '@webapp/core/components/CostSummary'
import { BudgetCategoryCardDetailsBreakdownStyled } from './styles/BudgetCategoryCardDetailsBreakdownStyled'
import { BudgetCategoryCardDetailsBreakdownRow } from '../BudgetCategoryCardDetailsBreakdownRow'
import { BudgetCategoryCardDetailsBreakdownVarianceRow } from '../BudgetCategoryCardDetailsBreakdownVarianceRow'

export interface IBudgetCategoryCardDetailsBreakdownProps {
  ariaLabel?: string
}

export const BudgetCategoryCardDetailsBreakdown = ({
  ariaLabel,
  children,
}: PropsWithChildren<IBudgetCategoryCardDetailsBreakdownProps>) => {
  return (
    <BudgetCategoryCardDetailsBreakdownStyled>
      <CostSummary ariaLabel={ariaLabel}>{children}</CostSummary>
    </BudgetCategoryCardDetailsBreakdownStyled>
  )
}

BudgetCategoryCardDetailsBreakdown.displayName =
  'BudgetCategoryCardDetailsBreakdown'
BudgetCategoryCardDetailsBreakdown.Row = BudgetCategoryCardDetailsBreakdownRow
BudgetCategoryCardDetailsBreakdown.VarianceRow =
  BudgetCategoryCardDetailsBreakdownVarianceRow
